import { atomWithQuery } from 'jotai/query'
import { atom } from 'jotai'
import { AxiosResponse } from 'axios'
import { axiosWithAuth, axiosWithImitator } from '../withAuth'
import { Profile } from '../../models/Profile'
import {
    IUpdateMyProfileData,
    IUpdateMyProfileUserCovers,
} from '../../components/modules/EditMyProfile'

interface keyValue {
    [id: string]: string
}

interface IAuthProfile {
    Afdeling: {
        Nummer: string
        Navn: string
    }
    AlleTRTillidshvervTypeListe: number[]
    BrugerMedlemsident: number
    BrugerSagsbehandlerInitialer: null | string
    Dagsdato: string
    KanBestilleNoteRapport: boolean
    ManglerTrKontaktoplysninger: boolean
    MinVersionAndroid: null | string
    MinVersionIOS: null | string
    RolleListe: string[]
    ServiceBesked: null | string
    SkalVilkaarGodkendes: boolean
    HarLoenindplaceringer: boolean
}

export type AuthProfile = {
    data?: IAuthProfile
    isImitator: boolean
    apiProfile?: Profile | undefined
}

const initialValue: AuthProfile = {
    data: undefined,
    isImitator: false,
    apiProfile: undefined,
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getProfile = async () => {
    const response = await axiosWithAuth.get(`/profil/hentbrugeropstartdata`)

    return response
}

const getProfileSupportInfo = async (): Promise<AxiosResponse> => {
    const response = await axiosWithAuth.get(
        '/profil/hentsupportkontaktoplysninger'
    )

    return response
}

const updateProfile = async (
    values: IUpdateMyProfileData
): Promise<AxiosResponse> => {
    const response = await axiosWithAuth.post(
        `/profil/opdaterbrugerprofil`,
        values
    )

    return response
}

const updateProfileUserCovers = async (
    values: IUpdateMyProfileUserCovers
): Promise<AxiosResponse> => {
    const response = await axiosWithAuth.post(
        `/profil/opdatertotalantalkollegaerbrugerdaekker`,
        values
    )

    return response
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getProfileByIdent = async (ident: number): Promise<any> => {
    const response = axiosWithAuth.get(
        `/profil/hentbrugerprofil?request.imiteretBrugerMedlemIdent=${ident}`
    )

    return response
}

const getMemberForImitating = (
    departmentNumber: string,
    name: string
): Promise<any> => {
    return axiosWithAuth.get(
        `/profil/soegtrtilimitering?request.afdelingsnummer=${departmentNumber}&request.fuldeNavn=${name}`
    )
}

const profileAtom = atom<AuthProfile>(initialValue)

const idAtom = atom(1)

const getProfileAtom = atomWithQuery((get) => ({
    queryKey: ['myProfile', get(idAtom)],
    queryFn: async ({ queryKey: [,] }) => {
        const response = await axiosWithAuth.get(`/profil/hentbrugerprofil`)
        const { data } = response
        return Profile.build(data)
    },
}))

export {
    profileAtom,
    getProfile,
    getProfileAtom,
    getProfileByIdent,
    getMemberForImitating,
    updateProfile,
    getProfileSupportInfo,
    updateProfileUserCovers,
}
